<template>
  <v-sheet
    height="100%"
    class="overflow-hidden edit-content-sheet"
  >
    <v-row align="center" class="edit-content-header px-4">
      <v-col class="edit-content-header__col">
        <v-icon class="edit-content-header__back" @click="changePage">mdi-arrow-left</v-icon>
        <span class="edit-content-header__title">{{spaceSelected.name}}</span>
      </v-col>
    </v-row>

    <v-divider />

    <router-view></router-view>
    <v-row class="edit-content-body">

      <v-col class="edit-content-body__col">
   


<v-col id="contents-container" cols="12" md="4" lg="3">
        <v-card style="border-radius: 20px" class="pb-5">
          <v-row>
            <v-col class="py-0">
              <CreateContents></CreateContents>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
   
  </v-col> 

</v-row>


  </v-sheet>
</template>

<script>
import axios from "axios";
import { mapState, mapActions, mapMutations } from "vuex";
import router from "vue-router";
import RightMenuAddNewQueue from "@/components/RightMenuAddNewQueue.vue";
import RightMenuEditQueue from "@/components/RightMenuEditQueue.vue";
import CreateContents from "@/components/CreateContents.vue";


export default {
  name: "Queues",
  components: {
    RightMenuAddNewQueue,
    RightMenuEditQueue,
    deleteDialog: false,
    CreateContents,
  },
  data() {
    return {
          checkbox: true,
          showAlertName: false,
    showAlertWidth: false,
    showAlertHeight: false,
      color3: '#f5b70e',
        color4: '#f6c231',
        color5: '#FFFFFFFF',
      deleteDialog: false,
      search: "",
      skeleton: true,
      selected: [],
      arrProposalData: [],     
    };
  },
  computed: {
        ...mapState("app", ["actualProject"]),

    ...mapState("queues", ["spaceSelected","allResouces","objQueueCont","allQueues","RightMenuAddNewQueue","showRightMenu","allSpaces","RightMenuEditQueue"]),

    headers() {
      return [
        { text: "", value: "icon", },
        { text: "Nombre", value: "name", align: "start", },
        { text: "Tipo", value: "type", },
        { text: "Sitio", value: "spaceName", },
        { text: "Stands", value: "numberResources", },
        { text: "", value: "Actions",  },
      ];
    },

  },
  methods: {
    ...mapMutations("queues", ["spaceActions","openRightMenuMutation","closeRightMenuMutation"]),
    ...mapActions("queues", ["getTicketStore","sendHtmlSpaceStore","getAllQueues","getAllSpaces","getAllResouces","editQueueStore","showRightMenuProposalStore","hideRightMenuProposalStore","rightMenuTrueNewDeviceTableStore","rightMenuTrueNewDeviceTableStore2","deleteMultipleQueues","deleteOneQueueStore"]),
    goToCampaignAs(role) {
      this.viewAsClient = true;
    },
    goResource(resource){

      this.spaceActions(resource);
      this.getTicketStore(resource.idResource);
      this.$router.push({
        name: "GeneralStandTurnMobile",
        params: { idSpace: resource }
      });
    },

    setClock(){
      let element = document.getElementById("hour");
      
      if(this.checkbox == false){
        element.style.display='none';     
      }else{
        element.style.display='';     
      }
    },

    hideAlertNameCont() {
      if (this.objQueueCont.name != "") {
        this.showAlertName = false;
      }
    },
    hideAlertWidthCont() {
      if (this.objQueueCont.width != "") {
        this.showAlertWidth = false;
      }
    },
    hideAlertHeightCont() {
      if (this.objQueueCont.height != "") {
        this.showAlertHeight = false;
      }
    },

    changePage() {
        this.$router.push({
            name: "ResumeSpaceMobile",
        });
        this.closeRightMenuMutation();
    },
    goAllQueues(){
      this.$router.push({
        name: "QueuesMobile",
      });
    },
    sendHtml(cont){

      if(cont.name == "" ||cont.name == undefined){
        this.showAlertName = true;
      } 
      if(cont.width == undefined){
        this.showAlertWidth = true;
       }
      if(cont.height == undefined){
        this.showAlertHeight = true;
      }

      if (this.showAlertName == false && this.showAlertWidth == false && this.showAlertHeight == false ) {
        cont.contentColor = this.color3
        cont.contentColor2 = this.color4
        cont.contentColor3 = this.color5
        if(this.checkbox == true){
          cont.clock_ = "on"
        }else{
          cont.clock_ = "off"
        }
        cont.project = this.actualProject.id
        let idProject = this.actualProject.id
        let idSpace = this.spaceSelected.idSpace
        let dataInfo = [cont, idProject,idSpace]
        
        this.sendHtmlSpaceStore(dataInfo);
        // this.objQueueCont = []
      }
    }
  },

  async created() {  

    let idProject = "";
    
    if (this.actualProject == undefined) {
      idProject = this.firstProject.id;
    } else {
      idProject = this.actualProject.id;
    }   
    
    await this.getAllSpaces(idProject);  
    await  this.getAllResouces(idProject);   
    await this.getAllQueues(idProject);
  },
  destroyed() {},
};
</script>

<style scoped>
.edit-content-sheet {
  position: relative;
  margin-top: 0;
  border-radius: 0;
}
.edit-content-header {
  background-color: #fff;
  min-height: 56px;
}
.edit-content-header__col {
  display: flex;
  align-items: center;
}
.edit-content-header__back {
  cursor: pointer;
}
.edit-content-header__title {
  margin-left: 12px;
  font-size: 18px;
  font-weight: 300;
  color: #777;
  white-space: nowrap;
}
.edit-content-body {
  height: 100%;
  max-height: calc(100vh - 125px);
  overflow: auto;
  position: relative;
  margin-top: 0;
  border-radius: 0;
  background-color: #f5f5f5;
}
.edit-content-body__col {
  background-color: #f5f5f5;
  padding: 12px;
}
a {
  text-decoration: none;
}
>>> .v-data-table__wrapper {
  height: calc(100vh - 207px);
  overflow: auto;
}
>>> th {
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/EditContentMobile.vue